<section class="branding-page">
  <section class="branding-shell">
    <!-- Top Bar: Standard 76px edge-to-edge header -->
    <header class="page-topbar hero-section branding-topbar">
      <div class="topbar-title-block page-header__title">
        <h1 class="page-title">Manage Brands</h1>
        <p class="page-subtitle helper-copy">
          Customize emails and document signing pages with your brand colors, logos, and more.
        </p>
      </div>

      <div class="page-header__actions">
        <button type="button" class="btn btn-primary primary-btn btn-purple" (click)="createBrand()">
          <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="10" y1="4" x2="10" y2="16"></line>
            <line x1="4" y1="10" x2="16" y2="10"></line>
          </svg>
          <span>Create New Brand</span>
        </button>
      </div>
    </header>

    <div class="branding-body branding-pane" aria-label="Branding settings">
      <!-- Feature Highlights Row Matching Figma (3 Cards) -->
      <section class="branding-features-grid" aria-label="Branding highlights">
        <h2 class="sr-only">Set up your Brands</h2>
        <div class="feature-card">
          <div class="feature-icon-box" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <line x1="9" y1="18" x2="15" y2="18"></line>
              <line x1="10" y1="22" x2="14" y2="22"></line>
              <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>
            </svg>
          </div>
          <div class="feature-text">
            <h3>Brand Colors &amp; Logos</h3>
            <p>Customize every touchpoint with your visual identity</p>
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-icon-box" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"></rect>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
            </svg>
          </div>
          <div class="feature-text">
            <h3>Branded Emails</h3>
            <p>Send signing invites and notifications in your brand voice</p>
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-icon-box" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
            </svg>
          </div>
          <div class="feature-text">
            <h3>Multi-Brand Contracts</h3>
            <p>Send contracts from different brands within one account.</p>
          </div>
        </div>
      </section>

      <!-- Search & Controls Toolbar Matching Figma -->
      <div class="branding-toolbar-row">
        <div class="branding-search-wrap">
          <input
            type="text"
            [(ngModel)]="searchQuery"
            placeholder="Search ..."
            class="branding-search-input"
          />
          <span class="search-icon-box" aria-hidden="true">
            <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="9" r="5.5"></circle>
              <line x1="13.5" y1="13.5" x2="17.5" y2="17.5"></line>
            </svg>
          </span>
        </div>

        <div class="toolbar-actions-right">
          <div class="sort-select-wrap">
            <select [(ngModel)]="sortBy" class="sort-select" aria-label="Sort brands">
              <option value="recent">Sort by</option>
              <option value="name">Name</option>
              <option value="default">Default First</option>
            </select>
            <span class="sort-chevron" aria-hidden="true">
              <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 8 10 12 14 8"></polyline>
              </svg>
            </span>
          </div>

          <div class="view-mode-toggle" role="group" aria-label="View switch">
            <button
              type="button"
              class="view-btn"
              [class.is-active]="viewMode === 'list'"
              (click)="viewMode = 'list'"
              aria-label="List view"
              title="List view"
            >
              <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <line x1="2" y1="4" x2="14" y2="4"></line>
                <line x1="2" y1="8" x2="14" y2="8"></line>
                <line x1="2" y1="12" x2="14" y2="12"></line>
              </svg>
            </button>
            <button
              type="button"
              class="view-btn"
              [class.is-active]="viewMode === 'grid'"
              (click)="viewMode = 'grid'"
              aria-label="Grid view"
              title="Grid view"
            >
              <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor">
                <rect x="2" y="2" width="5" height="5" rx="1.2"></rect>
                <rect x="9" y="2" width="5" height="5" rx="1.2"></rect>
                <rect x="2" y="9" width="5" height="5" rx="1.2"></rect>
                <rect x="9" y="9" width="5" height="5" rx="1.2"></rect>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Feedback Announcement (Screen-reader accessible) -->
      @if (copyFeedbackMessage) {
        <section class="branding-toast" aria-live="polite" role="status">
          <p>{{ copyFeedbackMessage }}</p>
          <button
            type="button"
            class="branding-toast__close"
            (click)="dismissCopyFeedback()"
            aria-label="Dismiss message"
          >
            ×
          </button>
        </section>
      }

      @if (copyErrorMessage) {
        <div class="alert-banner error">
          <p class="branding-state branding-state--error" aria-live="polite">{{ copyErrorMessage }}</p>
        </div>
      }

      @if (loading) {
        <div class="branding-state-wrap">
          <p class="branding-state">Loading brands…</p>
        </div>
      } @else if (errorMessage) {
        <div class="branding-state-wrap">
          <p class="branding-state branding-state--error">{{ errorMessage }}</p>
        </div>
      } @else if (filteredBrands.length === 0) {
        <div class="branding-state-wrap empty-state-wrap">
          <div class="empty-state-icon">
            <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
          </div>
          <h3>No brands have been created yet.</h3>
          <p>Get started by creating your first brand.</p>
        </div>
      } @else {
        <div class="brand-cards-stack" [class.grid-layout]="viewMode === 'grid'">
          @for (brand of filteredBrands; track trackByBrandId($index, brand)) {
            <article class="brand-card" [class.brand-card--menu-open]="isMenuOpen(brand.id)">
              <!-- Left: Logo + Info -->
              <div class="brand-card-left">
                <div class="brand-logo-container">
                  @if (brand.logoDataUrl) {
                    <img class="brand-logo-preview" [src]="brand.logoDataUrl" [alt]="brand.name + ' logo'" />
                  } @else {
                    <div class="brand-mark-box" [style.--brand-accent]="brand.primaryButtonColor || '#7E21D9'">
                      <span class="brand-mark-initials">{{ brandInitials(brand) }}</span>
                    </div>
                  }
                </div>

                <div class="brand-info-block">
                  @if (brand.isDefault) {
                    <span class="default-badge">
                      <span class="star-icon">★</span> DEFAULT
                      <span class="sr-only">Default Brand</span>
                    </span>
                  }
                  <h3 class="brand-title">{{ brand.name }}</h3>
                  <p class="brand-desc">{{ brand.emailDisplayName || 'Brand profile preview' }}</p>
                  <span class="updated-date-inline">
                    Updated: <strong>{{ (brand.updatedAt || brand.createdAt) | date:'MMMM d, y' }}</strong>
                  </span>
                </div>
              </div>

              <!-- Middle: Status & Updated Date -->
              <div class="brand-card-middle">
                <span class="status-badge-active">
                  <span class="dot">●</span> Active
                </span>
                <span class="updated-date-badge">
                  Updated: <strong>{{ (brand.updatedAt || brand.createdAt) | date:'MMMM d, y' }}</strong>
                </span>
              </div>

              <!-- Right: Action Buttons Matching Figma -->
              <div class="brand-card-actions">
                <button
                  type="button"
                  class="action-btn-outline"
                  (click)="handleBrandAction('edit', brand)"
                  aria-label="Edit Brand"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                  <span>Edit Brand</span>
                </button>

                <button
                  type="button"
                  class="action-btn-outline action-btn-copy"
                  [class.is-copied]="copiedBrandId === brand.brandId"
                  (click)="handleBrandAction('brand-id', brand)"
                  [attr.aria-label]="copyActionAriaLabel(brand)"
                >
                  @if (copiedBrandId === brand.brandId) {
                    <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="copied-check-icon">
                      <polyline points="4 10 8 14 16 6"></polyline>
                    </svg>
                    <span class="copied-label">Copied!</span>
                  } @else {
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    <span>Use BrandID</span>
                  }
                </button>

                <button
                  type="button"
                  class="action-btn-delete"
                  (click)="handleBrandAction('delete', brand)"
                  aria-label="Delete brand"
                  title="Delete brand"
                >
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </article>
          }
        </div>
      }
    </div>
  </section>
</section>
